import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const relationsMapFields: FieldInterface[] = [
  {
    key: 'positions',
    originKey: 'positions',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isMandatory,
  },
]

const relationsMapRelations: RelationInterface[] = []

export { relationsMapFields, relationsMapRelations }
